import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { Modal } from "@circleco/compass/components/Modal";

import { t } from "@/i18n-js/instance";

import { FullScreenConfetti } from "./FullScreenConfetti";

export const VersionActivationModalComponent = () => {
  const modal = useModal();

  const closeModal = () => {
    void modal.hide();
    modal.remove();
  };

  const onOpenChange = (open: boolean) => {
    if (!open) {
      closeModal();
    }
  };

  return (
    <>
      <FullScreenConfetti shouldCelebrate={modal.visible} />
      <Modal.Root open={modal.visible} onOpenChange={onOpenChange} size="sm">
        <Modal.Content>
          <Modal.Header title={t("version_activation_modal.title")} />
          <Modal.Body>
            <p className="text-primary text-md leading-6 tracking-tighter">
              {t("version_activation_modal.description")}
            </p>
          </Modal.Body>
          <Modal.Footer
            primaryAction={{
              label: t("version_activation_modal.cta"),
              onClick: closeModal,
            }}
          />
        </Modal.Content>
      </Modal.Root>
    </>
  );
};

const VersionActivationModal = ModalManager.create(() => (
  <VersionActivationModalComponent />
));

export const useVersionActivationModal = () => useModal(VersionActivationModal);
